import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useState } from "react";
import { generateAllArticleAiSummaries } from "@/lib/ai-summaries.functions";

export const Route = createFileRoute("/admin/ai-tools")({
  head: () => ({
    meta: [{ title: "AI Araçları · Admin" }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: AiToolsPage,
});

function AiToolsPage() {
  const runAll = useServerFn(generateAllArticleAiSummaries);
  const [status, setStatus] = useState<string>("");
  const [running, setRunning] = useState(false);

  const trigger = async (force: boolean) => {
    if (force && !confirm("TÜM yayında olan yazılar için AI özet yeniden üretilecek. Devam edilsin mi?"))
      return;
    setRunning(true);
    setStatus(force ? "Tüm yazılar için üretim başladı…" : "Eksik olanlar için üretim başladı…");
    try {
      const res = await runAll({ data: { force } });
      setStatus(`Bitti: ${res.succeeded}/${res.processed} başarılı, ${res.failed} başarısız.`);
    } catch (e) {
      setStatus(`Hata: ${e instanceof Error ? e.message : String(e)}`);
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="space-y-8">
      <header>
        <h1 className="font-serif text-3xl">AI toplu özet</h1>
        <p className="text-sm text-ink/60 mt-1 max-w-2xl">
          Yazıların <em>Bu Yazının Özeti</em> ve <em>Temel Çıkarımlar</em> bölümlerini toplu üretir.
          Kavram gömme ve Rapor↔Yazı gibi yazı-özel işler ilgili sekmelerinden yürütülür.
        </p>
      </header>

      <section className="border border-border rounded p-5 bg-ink/[0.02]">
        <div className="flex items-baseline justify-between mb-3">
          <h2 className="font-serif text-xl">Toplu üretim</h2>
          <span className="text-[10px] uppercase tracking-[0.18em] text-ink/60">Lovable AI · Gemini</span>
        </div>
        <p className="text-sm text-ink/70 mb-4 leading-relaxed">
          Otomatik cümle çıkarımı yerine yapay zeka tarafından hazırlanmış madde listesi kaydedilir.
        </p>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={() => trigger(false)}
            disabled={running}
            className="px-4 py-2 bg-ink text-paper rounded-full text-xs uppercase tracking-[0.2em] disabled:opacity-50"
          >
            Eksik olanları üret
          </button>
          <button
            onClick={() => trigger(true)}
            disabled={running}
            className="px-4 py-2 border border-ink rounded-full text-xs uppercase tracking-[0.2em] disabled:opacity-50"
          >
            Tümünü yeniden üret
          </button>
        </div>
        {status && <p className="mt-4 text-sm text-ink/85 whitespace-pre-wrap">{status}</p>}
      </section>
    </div>
  );
}
